import { filter, map, withLatestFrom } from 'rxjs';
import type { AgentInteractionRequested } from '@ardoq/api';
import type { UiCommandInteractionRequest } from '@ardoq/api-types';
import { assistantState$ } from './assistantState$';
import { isForActiveExchange } from './utils';
import type { UserFacingInteraction } from './types';
import { websocketChatInteractionRequested$ } from './websocketStreams$';

export type UiCommandInteraction = AgentInteractionRequested & {
  request: UiCommandInteractionRequest;
};

export const isUiCommandInteraction = (
  interaction: AgentInteractionRequested
): interaction is UiCommandInteraction =>
  interaction.request.kind === 'ui_command';

export const isUserFacingInteraction = (
  interaction: AgentInteractionRequested
): interaction is UserFacingInteraction =>
  interaction.request.kind !== 'ui_command';

export const activeUserFacingInteractionRequested$ =
  websocketChatInteractionRequested$.pipe(
    filter(isUserFacingInteraction),
    withLatestFrom(assistantState$),
    filter(isForActiveExchange),
    map(([interaction]) => interaction)
  );
